<fieldset ngModelGroup="internal_url">
    <div class="form-group row align-items-center" *ngFor="let internalUrl of internalUrls;let $index = index;">
        <label class="col-form-label text-bold col-sm-8 text-right" for="internal_url_operator_{{$index}}" translate>Operator*</label>
        <div class="col-sm-16">
            <angular-selector id="internal_url_operator_{{$index}}"
                    [(ngModel)]="internalUrl.operator"
                    [name]="'internalUrlOperator_' + $index"
                    [options]="operators"
                    valueAttr="value"
                    labelAttr="name"
                    placeholder="{{'Choose Operator' | translate }}"
                    [removeButton]="false"
                    [required]="internalUrls.length > 1">
            </angular-selector>
        </div>
        <label class="col-form-label text-bold col-sm-4 text-right" for="internal_url_value_{{$index}}" translate>Url*</label>
        <div class="col-sm-16">
            <input type="text"
                   class="form-control"
                   id="internal_url_value_{{$index}}"
                   [(ngModel)]="internalUrl.value"
                   [name]="'internalUrlValue' + $index"
                   [required]="internalUrls.length > 1"/>
        </div>
        <div class="col-sm-4 text-right pr-6">
            <button type="button"
                    [attr.aria-label]="'Remove internal URL' | translate"
                    class="btn btn-border-radius btn-secondary"
                    (click)="removeUrl($index)">
                <mon-icon class="text-link" monIconDirect="faTrashAlt"></mon-icon>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-40 offset-sm-8">
            <button
             [attr.aria-label]="'Add internal URL' | translate"
             type="button"
             class="btn btn-border-radius btn-secondary"
             (click)="addUrl()">
                <mon-icon class="text-link" monIconDirect="faPlus"></mon-icon>
            </button>
        </div>
    </div>
</fieldset>
